import { XCircleIcon } from '@heroicons/react/24/outline';
import { useNavigate } from '@tanstack/react-router';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { StatusCard } from '@/shared/ui';

/**
 * トークン制限超過ビュー
 *
 * AI機能の実行時にトークン制限超過（402）が発生した場合に表示する。
 * 管理者の場合のみ「プランと使用量を確認」ボタンを表示する。
 */
export const TokenLimitExceededView: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isAdmin = useSessionStore((s) => s.user?.role === 'admin');

  return (
    <StatusCard
      title={t('plan-usage.alert.limit-reached-title')}
      description={t('ai.errors.token-limit-exceeded-description')}
      icon={<XCircleIcon className="size-8 text-text-error" />}
      buttonText={isAdmin ? t('ai.errors.token-limit-exceeded-button') : undefined}
      onButtonClick={isAdmin ? () => navigate({ to: '/plan-usage' }) : undefined}
    />
  );
};
